export const dbDictionary = {
  primary: "Первинний прийом",
  secondaryShot: "Вторинний без діагностики",
  secondaryLong: "Вторинний з діагностикою",
  online: "Онлайн",
  offline: "Офлайн",
};
